import { render, staticRenderFns } from "./CrearEtiqueta.vue?vue&type=template&id=22ca894a"
import script from "./CrearEtiqueta.vue?vue&type=script&setup=true&lang=js"
export * from "./CrearEtiqueta.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports